import dynamic from 'next/dynamic';

const FormFileUpload = dynamic(() => import('./FormFileUpload'), { ssr: false });

export default FormFileUpload;
